import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Box,
  Typography,
} from '@mui/material';
import ArchiveIcon from '@mui/icons-material/Archive';
import InfoIcon from '@mui/icons-material/Info';
import { Info } from '@mui/icons-material';

interface ArchiveTaskModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ArchiveTaskModal({
  open,
  onClose,
  onConfirm,
}: ArchiveTaskModalProps) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        className: 'modal-dialog'
      }}
    >
      <DialogTitle>
        Aufgabe archivieren
      </DialogTitle>
      <DialogContent className="modal-content">
        <DialogContentText className="modal-content-text">
          Sind Sie sicher, dass Sie diese Aufgabe archivieren möchten? Die Aufgabe wird nicht
          gelöscht, sondern nur aus der normalen Ansicht ausgeblendet.
        </DialogContentText>
        <Box className="modal-info-box">
          <InfoIcon />
          <Typography className="modal-box-text modal-box-text-info">
            Archivierte Aufgaben können später wiederhergestellt werden.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button 
          onClick={onClose}
          className="modal-button modal-button-cancel"
        >
          Abbrechen
        </Button>
        <Button
          onClick={onConfirm}
          className="modal-button modal-button-warning"
        >
          <ArchiveIcon className="modal-icon" />
          Archivieren
        </Button>
      </DialogActions>
    </Dialog>
  );
}
